<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.international_editAgentBillNo')"
    width="400px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <el-form style="display: flex;" label-position="left" label-width="90px" :model="billing">
      <el-form-item :label="$t('SeaExport.CounterPartyBillingNo')">
        <el-input v-model="paramBilling.counterPartyBillingNo" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="saveEventHander">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="closeHandler">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { checkPartyBillingNoExist, savePartyBillingNo } from '@/api/clearing/billingNative'

export default {
  name: 'EditAgentBillNoDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    billing: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      paramBilling: {},
      counterPartyBillingNo: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.paramBilling = this.billing
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.closeHandler()
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.paramBilling = this.billing
      this.counterPartyBillingNo = this.billing.counterPartyBillingNo
    }
  },
  methods: {
    async saveEventHander() {
      // CARGO-626，代理账单号保存时要过滤前后两端空格
      this.paramBilling.counterPartyBillingNo = this.paramBilling.counterPartyBillingNo.trim()
      if (this.paramBilling.counterPartyBillingNo) {
        const res = await checkPartyBillingNoExist({
          branchId: this.paramBilling.branchId,
          billKey: this.paramBilling.uuid,
          billingType: this.paramBilling.billingType,
          counterPartyBillingNo: this.paramBilling.counterPartyBillingNo
        })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }
      // 调用api
      await savePartyBillingNo({
        billKey: this.paramBilling.uuid,
        counterPartyBillingNo: this.paramBilling.counterPartyBillingNo
      })
      this.$emit('editAgentBillNoSaveSuccessHandler')
      this.closeHandler()
    },
    closeHandler() {
      this.paramBilling.counterPartyBillingNo = this.counterPartyBillingNo
      this.innerVisible = false
    }
  }

}
</script>

<style>
</style>
